export default __webpack_public_path__ + "images/bc2efe7fc3dbbb8b84232b56172f1f32.png";